import axios from "axios";

import i18n from "../locale/i18n";
import { navigateTo } from "../routers/routeUtils";
import APP_ROUTES from "../routers/routeConstants";

const apiUrl = process.env.REACT_APP_API_URL as string;
const httpClient = axios.create();

httpClient.interceptors.request.use((config) => {
  config.baseURL = apiUrl;
  config.timeout = 10000;
  return config;
});

export const addAccessTokenInterceptor = (token: string) => {
  httpClient.interceptors.request.use((config) => {
    if (config.headers) {
      config.headers.Authorization = `Bearer ${token}`;
      config.headers["accept-language"] = i18n.language || "en";
    }
    return config;
  });
};

// Global error handling interceptor
httpClient.interceptors.response.use(
  (response) => {
    // Handle successful responses
    const { data } = response;

    if (data.message && data.message !== "success") {
      //   toast.success(data.message); // Display the message as a success toast
    }

    return response;
  },
  (error) => {
    // Handle errors globally and display a toast notification
    if (error.response) {
      const { status, data } = error.response;

      // Check if errors array is present in the error response
      if (data.errors && Array.isArray(data.errors)) {
        data.errors.forEach((errMsg: string) => {
          //   toast.error(errMsg);
        });
      }
    } else if (!error.response) {
      console.log("error", error);
      navigateTo(APP_ROUTES.NETWORK_ERROR);
    }

    return Promise.reject(error);
  }
);

export default httpClient;
